import axios from "axios";
import { getToken, removeToken } from "../utils/auth";
import { removeUserInfo } from "../utils/user";

// const baseURL =  window.location.protocol + "//" + window.location.host;
// const baseURL =  'http://localhost:8080/public/index.php';
const baseURL =  'https://webhook.manos-lux.com';

const api = axios.create({
	baseURL,
	headers: {
		"Accept": "application/json",
		"Content-Type": "application/json",
		"X-Requested-With": "XMLHttpRequest",
	},
	withCredentials: true,
});

// 请求拦截器
api.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token && config.headers) {
			config.headers.Token = `${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// 响应拦截器
api.interceptors.response.use(
	(response) => response.data,
	(error) => {
		if (error.response?.status === 401) {
			removeToken();
			removeUserInfo();
			window.location.href = "/login";
		}
		return Promise.reject(error);
	}
);

export const websiteConfigApi = {
	create: (data) => api.post("/api/websiteConfig/create", data),
	list: (params) => api.post("/api/websiteConfig/index", params),
	getById: (id) => api.get(`/api/websiteConfig/read`, {id}),
	update: (id, data) => api.post(`/api/websiteConfig/update`, {id, ...data}),
	delete: (id) => api.post(`/api/websiteConfig/delete`, {id}),
	getAllocatedPhone: (domain) => api.get(`/api/website_config/getAllocatedPhone`, { params: { domain } }),
	triggerConversionByCoupon: (data) => api.post("/api/manoswebhook/triggerConversionByCoupon", data),
};

export const authApi = {
	login: (username, password) => api.post("/admin/index/login", { username, password }),
	logout: () => api.post("/admin/index/logout"),
};

export const phoneGroupApi = {
	list: (params) => api.post("/api/phone_group/index", params),
	create: (data) => api.post("/api/phone_group/add", data),
	update: (id, data) => api.post(`/api/phone_group/edit`, { id, ...data }),
	delete: (id) => api.post(`/api/phone_group/del`, { id }),
};

export default api;
